import { IRHookFormTextField, RHookFormTextField } from '../RHookFormTextField';
import React, { FC } from 'react';

import { FieldLayout } from '../FieldLayout/FieldLayout';
import { LabelPosition } from '../../common/enums';
import { LayoutWithLabel } from '../../interfaces';

/**
 * Text fields allow users to enter text into a UI. They typically appear in forms and dialogs.
 * The EnhancedTextInputWR wrapper component is a complete form control using Material UI TextField including
 * a label, input, and help text. Websential is using the outlined variants.
 */
export interface IRHookFormTextFieldWithLabel extends IRHookFormTextField, LayoutWithLabel {
}

export const RHookFormTextFieldWithLabel: FC<IRHookFormTextFieldWithLabel> = ({
  id,
  label = "",
  required = false,
  testId,
  labelPosition = LabelPosition.Top,
  labelColumns = 4,
  fieldColumns = 8,
  placeholder = "",
  uppercase = false,
  readOnly = false,
  value,
  defaultValue,
  onChangeHandler
}: IRHookFormTextFieldWithLabel) => {
  return (
    <FieldLayout
      label={label}
      isRequired={required}
      testId={testId}
      labelPosition={labelPosition}
      labelColumns={labelColumns}
      fieldColumns={fieldColumns}
    >
      <RHookFormTextField
        id={id}
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        testId={id}
        uppercase={uppercase}
        readOnly={readOnly}
        onChangeHandler={onChangeHandler}
      />
    </FieldLayout>
  );
};